import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { sortBy, } from 'lodash';
import { isEmpty } from 'lodash';

import firebase from '../../firebase';
import { fieldDisplayValue } from '../../shared/util';
import { fields } from '../../shared/models/envelopeSchedule';
import AdminPage from '../hocs/AdminPage';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscriptionInTenant from '../hooks/useCollectionSubscriptionInTenant';
import TenantLink from '../TenantLink';

const db = firebase.firestore();
const envelopeSchedulesRef = db.collection('envelopeSchedules');
const { entries } = Object;

export default AdminPage(function AdminEnvelopeSchedule(props) {
  const {
    match: {
      params: { envelopeScheduleId },
    },
  } = props;
  const products = useCollectionSubscriptionInTenant(db.collection('products').orderBy('code'));
  const envelopeProducts = useCollectionSubscriptionInTenant(db.collection('envelopeProducts').orderBy('code'));
  const productTypes = sortBy(useCollectionSubscriptionInTenant(db.collection('productTypes')), _ => _.createdAt.toDate());
  const events = useCollectionSubscriptionInTenant(db.collection('events'));
  const userTags = useCollectionSubscriptionInTenant(db.collection('userTags').orderBy('createdAt'));
  const envelopeSchedule = useDocumentSubscription(envelopeSchedulesRef.doc(envelopeScheduleId), [envelopeScheduleId]);
  const deliveryHistoriesRef = db.collection(`envelopeSchedules/${envelopeScheduleId}/deliveryHistories`);
  const deliveryHistories = useCollectionSubscriptionInTenant(deliveryHistoriesRef.limit(1));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [envelopeSchedule]);

  return (
    envelopeSchedule != null && (
      <div className="admin-user container">
        <div className="p-4 bg-white my-4">
          <div className="d-flex justify-content-center mb-3">
            <h4>郵便スケジュール詳細</h4>
          </div>
          <div className="d-flex justify-content-end mb-3 gap-2 flex-wrap text-nowrap">
            {isEmpty(deliveryHistories) || (
              <Button tag={TenantLink} to={`/admin/envelopeSchedules/${envelopeSchedule.id}/deliveryHistories`} target="_blank">
                発送履歴
              </Button>
            )}
          </div>
          <div>
            <table className="table table-bordered">
              <tbody className="thead-light">
                {entries({
                  ...fields({ products, envelopeProducts, productTypes, events, userTags, }),
                }).map(([fieldName, fieldSetting]) => {
                  const { label } = fieldSetting;
                  return (
                    <tr key={fieldName}>
                      <th style={{ width: 200 }}>{label}</th>
                      <td style={{ whiteSpace: 'pre-line' }}>{fieldDisplayValue(envelopeSchedule[fieldName], fieldSetting)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  );
});
